/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

export const SET_NO_ORGANIZATION = 'SET_NO_ORGANIZATION';
export const GET_ORGANIZATIONS_LIST = 'GET_ORGANIZATIONS_LIST';
export const GET_MODULES_FOR_APPLICATION = 'GET_MODULES_FOR_APPLICATION';
export const GET_APPLICATIONS_FOR_ORGANIZATION = 'GET_APPLICATIONS_FOR_ORGANIZATION';
export const SET_GLOBAL_ROLE_BUILTIN_POLICIES = 'SET_GLOBAL_ROLE_BUILTIN_POLICIES';
export const ADD_MODULE = 'ADD_MODULE';
export const SET_BUILTIN_POLICIES_TO_ASSOCIATE = 'SET_BUILTIN_POLICIES_TO_ASSOCIATE';
export const CLEAR_BUILTIN_POLICIES_TO_ASSOCIATE = 'CLEAR_BUILTIN_POLICIES_TO_ASSOCIATE';
